import React from 'react';

const Admin = () => {
  return <h1>Whoa an admin page!</h1>;
};

export default Admin;
